export type CtaType = "tripadvisor" | "google" | "instagram" | "bestiebite" | "menu";

export interface LinkTreeCta {
  type: CtaType;
  label: string;
  url: string;
  isExternal: boolean;
  isMock?: boolean;
}

export interface LinkTreeVenue {
  slug: string;
  name: string;
  address: string;
  placeId: string;
  ctas: readonly LinkTreeCta[];
}

const LINK_TREE_VENUES: readonly LinkTreeVenue[] = [
  {
    slug: "pastaincorso_28795",
    name: "Pasta In Corso",
    address: "Corso Vittorio Emanuele II, 273-275, 00186 Roma",
    placeId: "28795",
    ctas: [
      {
        type: "menu",
        label: "Scopri il Menu",
        url: "https://www.pastaincorso.it/menus/",
        isExternal: true,
      },
      {
        type: "tripadvisor",
        label: "TripAdvisor",
        url: "https://www.tripadvisor.it/UserReviewEdit-g187791-d13477527-Pasta_In_Corso-Rome_Lazio.html",
        isExternal: true,
      },
      {
        type: "google",
        label: "Google",
        url: "https://g.page/r/CciGr2l2v86xEAE/review",
        isExternal: true,
      },
      {
        type: "instagram",
        label: "Instagram",
        url: "https://www.instagram.com/pastaincorso/",
        isExternal: true,
      },
      {
        type: "bestiebite",
        label: "Vinci un premio con Bestie Bite",
        url: "/",
        isExternal: false,
      },
    ],
  },
  {
    slug: "pastaincorso-pantheon_8112",
    name: "Pasta in Corso Pantheon",
    address: "Via della Maddalena, 43, 00186 Roma",
    placeId: "8112",
    ctas: [
      {
        type: "menu",
        label: "Scopri il Menu",
        url: "https://www.pastaincorso.it/menus/",
        isExternal: true,
      },
      {
        type: "tripadvisor",
        label: "TripAdvisor",
        url: "https://tripadvisor.com/UserReviewEdit-g187791-d25157279-Pasta_in_Corso_Pantheon-Rome_Lazio.html",
        isExternal: true,
      },
      {
        type: "google",
        label: "Google",
        url: "https://g.page/r/CVGtxuot8u3XEAE/review",
        isExternal: true,
      },
      {
        type: "instagram",
        label: "Instagram",
        url: "https://instagram.com/pastaincorso/",
        isExternal: true,
      },
      {
        type: "bestiebite",
        label: "Vinci un premio con Bestie Bite",
        url: "/",
        isExternal: false,
      },
    ],
  },
  {
    slug: "pastaincorso-cavour_15853",
    name: "Pasta in Corso Cavour-Prati",
    address: "Piazza Camillo Benso Conte di Cavour, 17/B, 00193 Roma",
    placeId: "15853",
    ctas: [
      {
        type: "menu",
        label: "Scopri il Menu",
        url: "https://www.pastaincorso.it/menus/",
        isExternal: true,
      },
      {
        type: "tripadvisor",
        label: "TripAdvisor",
        url: "https://tripadvisor.com/UserReviewEdit-g187791-d27734823-Pasta_In_Corso_Cavour_prati-Rome_Lazio.html",
        isExternal: true,
      },
      {
        type: "google",
        label: "Google",
        url: "https://g.page/r/CTaoP9bV44g0EBI/review",
        isExternal: true,
      },
      {
        type: "instagram",
        label: "Instagram",
        url: "https://instagram.com/pastaincorso/",
        isExternal: true,
      },
      {
        type: "bestiebite",
        label: "Vinci un premio con Bestie Bite",
        url: "/",
        isExternal: false,
      },
    ],
  },
  {
    slug: "pastaincorso-monti_66827",
    name: "Pasta in Corso Monti-Colosseo",
    address: "Via dei Serpenti, 9, 00184 Roma",
    placeId: "66827",
    ctas: [
      {
        type: "menu",
        label: "Scopri il Menu",
        url: "https://www.pastaincorso.it/menus/",
        isExternal: true,
      },
      {
        type: "tripadvisor",
        label: "TripAdvisor",
        url: "https://tripadvisor.com/UserReviewEdit-g187791-d34120065-Pasta_In_Corso_Monti-Rome_Lazio.html",
        isExternal: true,
      },
      {
        type: "google",
        label: "Google",
        url: "https://search.google.com/local/writereview?placeid=ChIJC6gsNP1hLxMRDsnhNRKZR5A",
        isExternal: true,
      },
      {
        type: "instagram",
        label: "Instagram",
        url: "https://instagram.com/pastaincorso",
        isExternal: true,
      },
      {
        type: "bestiebite",
        label: "Vinci un premio con Bestie Bite",
        url: "/",
        isExternal: false,
      },
    ],
  },
] as const;

export function getVenueBySlug(slug: string): LinkTreeVenue | undefined {
  return LINK_TREE_VENUES.find((venue) => venue.slug === slug);
}

export { LINK_TREE_VENUES };
